module.exports = __webpack_public_path__ + "img/Business.05115c99.jpg";